function accept(message, callback) {

	if (!message && !callback) {
		console.error('accept > message and callback undefined');
		return false;	
	}

	if (!message) {
		console.error('accept > message undefined');
		return false;	
	}
	if (typeof message != 'string') {
		console.error('accept > message is not a string');
		return false;
	};

	if (!callback) {
		console.error('accept > callback undefined');
		return false;	
	}
	if (typeof callback != 'function') {
		console.error('accept > callback is not a function');
		return false;
	};

	let data = {};

	data.body = $('body');
	data.identifier = Math.floor(Math.random() * (99999 - 1)) + 1;

	data.openAccept = function () {
		data.accept.addClass('is--active');
	}

	data.closeAccept = function () {
		data.accept.removeClass('is--active');
	}

	data.html = `
		<div id="accept-${data.identifier}" class="snap snap--confirm">
			<div class="snap__wrapper">
				<p class="snap__text">${message}</p>
				<div class="snap__button">
					<button class="button button--primary button--ms button--block" data-accept="yes">SI</button>
					<button class="button button--white button--ms button--block" data-accept="no">NO</button>
				</div>
			</div>
		</div>
	`;

	data.body.append(data.html);

	data.accept = $(`#accept-${data.identifier}`);
	data.button_no = data.accept.find('[data-accept="no"]');
	data.button_yes = data.accept.find('[data-accept="yes"]');

	data.openAccept();

	data.button_no.on('click', data.closeAccept);
	data.button_yes.on('click', function () {
		data.closeAccept();
		callback();
	});
}